module.exports = __webpack_public_path__ + "static/media/Trouser Image - Opt 1 - 1340 x 650.b976e02c.jpg";